<template>
	<div>
		<!-- Login Dialog -->
        <v-dialog v-model="$store.state.loginDialog" persistent :fullscreen="$vuetify.breakpoint.xsOnly" max-width="400px" >
            <v-card tile class="pt-2 pb-3">
                <v-toolbar card color="white" class="py-1">
                    <v-avatar size="32">
                        <img src="/assets/users.png">
                    </v-avatar>
                    <v-toolbar-title>Sign in to your account</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="$store.state.loginDialog = !$store.state.loginDialog">mdi-window-close</v-icon>
                </v-toolbar>
                <v-divider light></v-divider>
                
                <v-form @submit="signIn" class="px-3 mt-4" ref="signIn">
                    <v-text-field label="Email Address" flat v-model="signInEmail" :rules="$store.state.emailRules" solo prepend-inner-icon="mdi-mail-ru" class="text-field-no-curve mb-2" color="#32CD32"></v-text-field>

                    <v-text-field :type="show ? 'text' : 'password'" label="Password" flat v-model="signInPwd" prepend-inner-icon="mdi-lock-outline" :rules="$store.state.pwdRules"  solo class="text-field-no-curve" :append-icon="show ? 'mdi-eye-check-outline' : 'mdi-eye-off-outline'" @click:append="show = !show" color="#32CD32"></v-text-field>
                    

                    <v-btn type="submit" :loading="loginLoader" block dark color="primary" class="mx-0 mt-2">Log in</v-btn>

                    <div class="mb-1 mt-3">
                        <v-btn :disabled="loginLoader" flat small flat color="grey"  @click="forget = true">Forgot Password?</v-btn>
                    </div>

                    <v-divider light></v-divider>
                        
                    <div>
                    	Don't have an account?<v-btn :disabled="loginLoader" color="primary" flat class="font-weight-medium" @click="registerHandler()">Register</v-btn>
                    </div>
                </v-form>
            </v-card>
            <v-dialog v-model="forget" max-width="350px">
                <v-card>
                    <v-card-title>
                        Password Recovery
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                        type="email"
                        label="Enter your email address..."
                        v-model="recoveryEmail"
                        item-value="text"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" :loading="reseting" flat @click="resetPass">Send Reset Email</v-btn>
                        <v-btn color="primary" flat @click="forget=false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-dialog>

        <!-- Sign Up Dialog -->
        <v-dialog v-model="$store.state.registerDialog" persistent :fullscreen="$vuetify.breakpoint.xsOnly" max-width="450px" >
            <v-card tile class="pb-3">
                <v-toolbar card color="white" class="bb-hero1 py-2">
                    <v-avatar size="32">
                        <img src="/assets/users.png">
                    </v-avatar>
                    <v-toolbar-title>Create an account</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon @click="$store.state.registerDialog = !$store.state.registerDialog">mdi-window-close</v-icon>
                </v-toolbar>
                
                <v-form @submit="signUp" class="px-3 pt-4 pb-2" ref="signUp">

                    <v-text-field label="Full Name" flat v-model="regName" :rules="$store.state.inputRules" solo prepend-inner-icon="mdi-account-tie-outline" class="text-field-no-curve" color="#32CD32"></v-text-field>

                    <v-text-field label="Email Address" flat v-model="regEmail" :rules="$store.state.emailRules" solo prepend-inner-icon="mdi-mail-ru" class="text-field-no-curve" color="#32CD32"></v-text-field>

                    <v-text-field :type="show2 ? 'text' : 'password'" label="Password" flat v-model="regPwd" prepend-inner-icon="mdi-lock-outline" :rules="$store.state.pwdRules"  solo class="text-field-no-curve" :append-icon="show2 ? 'mdi-eye-check-outline' : 'mdi-eye-off-outline'" @click:append="show2 = !show2" color="#32CD32"></v-text-field>

                    <v-tooltip top>
                        <v-text-field type="number" label="Mobile Number (eg: 09036*****)" flat v-model="regMobile" :rules="$store.state.mobileRules" solo prepend-inner-icon="mdi-phone-outline" class="text-field-no-curve" color="#32CD32" slot="activator"></v-text-field>

                        <span>Please ensure you provide a working phone number, because this the only way we can contact you!</span>
                    </v-tooltip>
                    <v-checkbox v-model="checkbox" :rules="[v => v || 'You must agree to continue!']" label="Do you agree to our Terms & Conditions?" class="mt-0" required></v-checkbox>

                    <v-btn type="submit" :loading="regLoader" block dark color="primary" class="mx-0">Register</v-btn>

                    <v-btn @click="showTerms" :disabled="regLoader" flat small color="grey">Terms & Conditions <v-icon>mdi-chevron-right</v-icon></v-btn>

                    <v-divider light></v-divider>
                        
                    <div>Already have an account?<v-btn :disabled="regLoader" color="primary" flat class="font-weight-medium" @click="loginHandler()">Log in</v-btn></div>
                </v-form>
            </v-card>
        </v-dialog>
	</div>
</template>

<script>
import { Auth } from '@/firebase/auth';
import { DB } from '@/firebase/db';
export default {
    data() {
        return {
            loginLoader: false,
            regLoader: false,
            show: false,
            show2: false,
            signInEmail: "",
            signInPwd: "",
            regName: "",
            regEmail: "",
            regPwd: "",
            regMobile: "",
            checkbox: false,
            recoveryEmail: "",
            forget: false,
            reseting: false
        }
    },
    methods: {
        registerHandler() {
            var self = this

            this.$store.state.loginDialog = false
            setTimeout(() => {
                self.$store.state.registerDialog = true
            }, 300)
            this.$refs.signIn.reset()
            this.$refs.signIn.resetValidation()
        },
        loginHandler() {
            var self = this

            this.$store.state.registerDialog = false
            setTimeout(() => {
                self.$store.state.loginDialog = true
            }, 300)
            this.$refs.signUp.reset()
            this.$refs.signUp.resetValidation()
        },
        showTerms() {
            this.$store.state.registerDialog = false
            this.$router.push('/terms')
        },
        resetPass() {
            if(this.recoveryEmail) {
                if (/.+@.+/.test(this.recoveryEmail)) {
                    this.reseting = true
                    Auth.sendPasswordResetEmail(this.recoveryEmail)
                    .then(() => {
                        this.reseting = false
                        this.$store.dispatch('setSnackText', "A Password email has been sent to your email")
                        this.$store.dispatch('setSnackState', true)
                        this.forget = false
                        this.recoveryEmail = ""
                    })
                    .catch(err => {
                        this.reseting = false
                        this.$store.dispatch('setSnackText', "Error: "+ err)
                    })
                } else {
                    this.$store.dispatch('setSnackText', "Provided email address is invalid")
                }
            } else {
                this.$store.dispatch('setSnackText', "You didn't enter any email")
            }
        },
        signIn(e) {
            e.preventDefault()

            if(this.$refs.signIn.validate()){
                this.loginLoader = true
                
                // Log user in
                Auth.signInWithEmailAndPassword(this.signInEmail, this.signInPwd).then(() => {

                    // Handles Ui states
                    this.loginLoader = false
                    this.$store.state.loginDialog = false
                    this.$store.dispatch('setSnackText', "You successfully logged!")

                    this.$refs.signIn.reset()
                    this.$refs.signIn.resetValidation()
                }).catch(err => {
                    this.loginLoader = false
                    this.$store.dispatch('setSnackText', err)
                    console.log(err)
                })
            }
        },
        signUp(e) {
            e.preventDefault()
            
            if(this.$refs.signUp.validate()){
                this.regLoader = true

                // Signs Up a user
                Auth.createUserWithEmailAndPassword(this.regEmail, this.regPwd).then(cred => {
                    var date = new Date()

                    return DB.collection('users').doc(cred.user.uid).set({
                            uid: cred.user.uid,
                            name: this.regName,
                            mobile: this.regMobile,
                            email: this.regEmail,
                            activated: false,
                            validity: date.getTime(),
                            createdOn: date.getTime(),
                        })
                }).then(() => {
                    var user = Auth.currentUser;

                    return user.sendEmailVerification()
                })
                .then(() => {
                    // Handles Ui and Ux
                    this.regLoader = false
                    this.$store.state.registerDialog = false
                    this.$router.push('/')

                    this.$refs.signUp.reset()
                    this.$refs.signUp.resetValidation()

                    alert('Your account has been successfully created! Check your email for verification link')
                })
                .then(() => {
                    let statRef = DB.collection("analysis").doc("stats")
                    let newCount = 0
            
                    DB.runTransaction((transaction) => {
                        // This code may get re-run multiple times if there are conflicts.
                        return transaction.get(statRef).then((sfDoc) => {
                            if (!sfDoc.exists) {
                                throw "Document does not exist!";
                            }

                            newCount = sfDoc.data().users + 1;

                            transaction.update(statRef, { users: newCount })
                        })
                    })
                })
                .catch(err => {
                    console.log(err)
                    this.regLoader = false
                    this.$store.dispatch('setSnackText', err)
                })
            }
        }
    },
    created() {
        
    },
    computed: {}
};
</script>

<style scoped>
    
</style>